export const INTERNAL_ROLES = [
    { id: 'REPORTING', description: 'Reporting' },
    { id: 'SYSTEM_ADMIN', description: 'System Admin' },
    { id: 'CS_ADMIN', description: 'Cs Admin' }
]
